import React from 'react';
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { Start } from '../components/Start';
import { Portfolio } from '../components/Portfolio';
import { Resume } from '../components/Resume';
import { Contact } from '../components/Contact';
import { HeaderNav } from '../components/layout/HeaderNav';
import { Services } from '../components/Services';
import { Footer } from '../components/layout/Footer';
import { Error } from '../components/Error';
import { Project } from '../components/Project';

export const MyRoutes = () => {
  return (

    <BrowserRouter>
      {/* Header & navigation */}
      <HeaderNav />
      {/* Main content */}
      <section className="content">
        <Routes>
          {/* navbar routes */}
          <Route path="/" element={<Navigate to="/start" />} />
          <Route path="/start" element={<Start />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/services" element={<Services />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/contact" element={<Contact />} />

          {/* portfolio item routes */}
          <Route path="/project/:id" element={<Project/>} />

          {/* error route */}
          <Route path="*" element={<Error />} />
        </Routes>
      </section>


      {/* Footer */}

      <Footer />

    </BrowserRouter>

  )
}
